// Module
var code = "<div class=\"basket-qty-indicator__container\"> <span class=\"basket-qty-indicator__value\" data-qty=\"{{totalCount}}\"></span> </div>";
// Exports
module.exports = code;